import { useParams } from 'react-router-dom';

export const useBudgetId = () => {
  const { id } = useParams<Dictionary<string>>();

  return id!;
};
